import axios from '../services/api.service';

export const userGetInitialization = async () => {

  try {
    const { data: response } = await axios.get('/auth/initialization')
    console.log(response);
    return response.data;
  } catch (error) {
    console.error(error)
  }
};

export const getUserInfo = () => async () => {
  try {
    await axios.get('/users/info')
  } catch (e) {
  }
}

export const userGetInfo = async () => {

  try {
    const { data: response } = await axios.get('/users/info')
    // Backend returns {"user": {...}}, so we need to access response.user
    // axios wraps the response in data, so response is already the JSON body
    return response?.user || response?.data?.user || response?.data?.result || response?.data || response;
  } catch (error) {
    console.error(error)
    return null;
  }
};

// Email change is a two-step flow: this only asks the backend to mail a
// confirmation link to the NEW address. The account keeps its current email
// until that link is opened. Returns 'success' or the backend's message.
export const userRequestEmailChange = async (email: string) => {
  try {
    await axios.post('/users/email-change/request', { email });
    return 'success';
  } catch (error: any) {
    console.error(error)
    return error?.response?.data?.error || 'error';
  }
};

// Consumes the token from the emailed link; this is what actually applies the
// new address. Callable while signed out — the token identifies the user.
export const userConfirmEmailChange = async (token: string) => {
  try {
    const { data: response } = await axios.post('/users/email-change/confirm', { token });
    return { email: response?.email || null, err: null };
  } catch (error: any) {
    console.error(error)
    return { email: null, err: error?.response?.data?.error || 'error' };
  }
};

export const userUpdatePassword = async (data: object) => {
  try {
    await axios.put('/users/update-password', data);
    return 'success';
  } catch (error: any) {
    console.error(error)
    // Surface the backend's clear message (e.g. "current password is incorrect")
    // instead of a generic failure string.
    return error?.response?.data?.error || 'error';
  }
};

export const userForgotPassword = async (data: object) => {
  try {
    await axios.post('/users/forgot-password', data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const userResetPassword = async (data: object) => {
  try {
    await axios.post('/users/reset-password', data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const userPostCheckout = async (data: object) => {
  try {
    const { data: response } = await axios.post('/api/company/checkout', data);
    return response;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const userPostPortal = async (data: object) => {
  try {
    const { data: response } = await axios.post('/api/company/portal', data);
    return response;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};